<template>
	<section id="the-company">
		<div class="row">
			<div class="col-12">
				<h2>1989</h2>
				<h1 v-if="'en' === currentLanguage">CÉH was founded</h1>
				<h1 v-if="'hu' === currentLanguage">CÉH megalapítása</h1>
				<h1 v-if="'de' === currentLanguage">CÉH wurde gegründet</h1>

				<ul v-if="'en' === currentLanguage" ref="list">
					<li :class="{ show: shown.indexOf(1) > -1 }">Today, CÉH is home to <strong>350+ colleagues</strong>,</li>
					<li :class="{ show: shown.indexOf(2) > -1 }">of which <strong>300+ have a master degree</strong> in engineering.</li>
					<li :class="{ show: shown.indexOf(3) > -1 }">Together with our <strong>100+</strong> collaborating <strong>partners</strong>,</li>
					<li :class="{ show: shown.indexOf(4) > -1 }">we work on <strong>150+ projects</strong> every year</li>
					<li :class="{ show: shown.indexOf(5) > -1 }">and manage <strong>2 billion EUR</strong> project value annual.</li>
				</ul>

				<ul v-if="'hu' === currentLanguage" ref="list">
					<li :class="{ show: shown.indexOf(1) > -1 }">A CÉH ma <strong>350+ munkatársat</strong> foglalkoztat,</li>
					<li :class="{ show: shown.indexOf(2) > -1 }">ebből <strong>300+ főállású mérnök.</strong></li>
					<li :class="{ show: shown.indexOf(3) > -1 }">A <strong>100+</strong> együttműködő <strong>partnerünkkel</strong>,</li>
					<li :class="{ show: shown.indexOf(4) > -1 }">évente <strong>150+ projekten</strong> dolgozunk együtt,</li>
					<li :class="{ show: shown.indexOf(5) > -1 }"><strong>2 milliárd EUR </strong> beruházási értéket kezelve.</li>
				</ul>

				<ul v-if="'de' === currentLanguage" ref="list">
					<li :class="{ show: shown.indexOf(1) > -1 }">CÉH beschäftigt mehr als <strong>350+ Mitarbeiter</strong>,</li>
					<li :class="{ show: shown.indexOf(2) > -1 }">von denen <strong>300+ Vollzeitingenieure</strong> sind.</li>
					<li :class="{ show: shown.indexOf(3) > -1 }">Wir arbeiten zusammen mit unseren <strong>100+ Kooperationspartnern</strong>,</li>
					<li :class="{ show: shown.indexOf(4) > -1 }">an mehr als <strong>150+ Projekten</strong> und</li>
					<li :class="{ show: shown.indexOf(5) > -1 }"><strong>2 Milliarden Euro</strong> Investitionswert pro Jahr abgewickelt.</li>
				</ul>
				
				<p v-if="'de' === currentLanguage">Wir sind sehr stolz auf die gemeinsame Arbeit und freuen uns auf ein noch erfolgreicheres Jahr. Begleiten Sie uns in unserer Geschichte <a :href="`/${currentLanguage}/contact`">Kontaktiere uns</a></p>
				<p v-if="'en' === currentLanguage">We are a very proud of the work that we have done together, and are looking forward to an even more successful year. Join us in our story <a :href="`/${currentLanguage}/contact`">Contact us</a></p>
				<p v-if="'hu' === currentLanguage">Büszkék vagyunk az ez évi eredményeinkre és reméljük, hogy a jövő év még sikeresebb lesz. Csatlakozz a történetünkhöz, <a :href="`/${currentLanguage}/contact`">vedd fel velünk a kapcsolatot.</a></p>
			</div>
		</div>
	</section>
</template>

<script>

	export default {
		mounted() {
			setTimeout(() => {
				this.showText();
			}, 100);
		},
		computed: {
			currentLanguage() {
				return this.$route.params.lang || 'en';
			}
		},
		methods: {
			showText() {
				for (var i = 0; i < 10; i++) {
					var index = i;
					this.show(i);
				}
			},
			show(index) {
				setTimeout(() => {
					this.shown.push(index);
				}, index * 1500);
			}
		},
		data() {
			return {
				shown: []
			}
		}

	}
</script>

<style lang="scss" scoped>
	
	@import './../../../sass/variables';

	#the-company {
		position: relative;
		z-index: 10;

		a {
			color: $light-blue;
		}

		@media screen and (max-width: $tablet-max) {
			padding-right: 15px;
		}
	}
	
	h1 {
		font-family: $famNormal;
		font-size: 30px;
		color: $black;

		&:before,
		&:after {
			display: none;
		}
	}

	h2 {
		font-family: $famHeader;
		font-weight: bold;
		margin-bottom: 0;
		font-size: 50px;
		color: $blue;

		&:before,
		&:after {
			display: none;
		}
	}

	p {
		font-size: 20px;
		width: 70%;
			
		@media screen and (max-width: $tablet-max) {
			font-size: 18px;
		}

		@media screen and (max-width: $tablet-max) {
			width: 95%;
		}
		
		a {
			font-size: 20px;
			
			@media screen and (max-width: $tablet-max) {
				font-size: 18px;
			}
		}
	}

	ul {
		transform: translate(-50%, 0);
	    margin: 30px auto 100px;
	    display: inline-block;
	    position: relative;
		left: 50%;

		@media screen and (max-width: $tablet-max) {
			transform: translate(0);
		    margin: 30px 0 50px;
			left: 0;
		}
	}

		li {
			transition: all 1s 1000ms;
			color: transparent;
			line-height: 1.2;
			font-size: 28px;

			@media screen and (max-width: $tablet-max) {
				font-size: 18px;
			}

			strong {
			    vertical-align: middle;
				display: inline-block;
				transition: all 1s;
				position: relative;
				color: transparent;
				overflow: hidden;
				padding: 10px 0;
				top: -3px;

				&:before {
					transform: translate(-105%, 0%);
					background-color: $light-blue;
					transform-origin: 0, 0;
					position: absolute;
					display: block;
					height: 100%;
					content: '';
					width: 200%;
					left: 0;
					top: 0;
				}
			}

			&.show {
				transition: color 1s 1s;
				color: $black;

				strong {
					transition: color 10ms 250ms;
					color: $black;

					&:last-of-type {
						transition: color 10ms 350ms;

						&:before {
							transition: all 800ms cubic-bezier(0.3, 0.8, 0.6, 0.1) 100ms;
						}
					}

					&:before {
						transition: all 800ms cubic-bezier(0.3, 0.8, 0.6, 0.1);
						transform: translate(105%, 0%);
					}
				}
			} 	
		}

</style>
